/** biome-ignore-all lint/style/useNamingConvention: just the way it is */
'use client';

import { ObservedScripts } from 'constants/constants';
import useClientSideErrorReporting from 'hooks/useClientSideErrorReporting';
import { useEffect } from 'react';
import thirdPartyScriptErrorObserver from 'utils/miscUtils/thirdPartyScriptErrorObserver';
import { getLocalStorageObject, updateLocalStorageObject } from '@/app_lib/utils/localStorageUtils';

// App wrapper for executing client-side utilities
export const AppClientWrapper = ({ children }: { children: React.ReactNode }) => {
  // Mount error reporting utilities for client & 3rd party scripts
  useClientSideErrorReporting();
  thirdPartyScriptErrorObserver(ObservedScripts);

  useEffect(() => {
    const checkoutTrackingProps = getLocalStorageObject('checkoutTrackingProps');
    const millisecondsInASecond = 1000;
    const oneDay = 24 * 60 * 60 * millisecondsInASecond;
    if (checkoutTrackingProps?.updatedAt && Date.now() - checkoutTrackingProps.updatedAt > oneDay) {
      // Clear out old tracking exposure and referral param properties after 24 hours
      updateLocalStorageObject('checkoutTrackingProps', {
        checkout_referral_params: null,
        experience_action_id: null,
        experience_id: null,
        login_method: null,
        login_type: null,
        lts: null,
        offer_id: null,
        persistExposureProps: null,
        persistReferralParams: null,
        template_id: null,
        template_variant_id: null,
        terms: null,
      });
    }
  }, []);

  return <>{children}</>;
};
